import script from "./StudentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./StudentDashboard.vue?vue&type=style&index=0&id=c32dff38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c32dff38"]])

export default __exports__